/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.health.outcomes'},
});

const OutcomesItem = () => (
  <RouteLinkItem
    route="midas/settings/health/outcomes"
    title={messages.title}
  />
);

export default OutcomesItem;
